// cart-drawer.js — slide-out basket. Extracted from snippets/cart-drawer.liquid.

(function () {
  var overlay = document.querySelector('[data-cd-overlay]');
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer || !overlay) return;
  var body = drawer.querySelector('[data-cd-body]');
  var foot = drawer.querySelector('[data-cd-foot]');
  var subEl = drawer.querySelector('[data-cd-subtotal]');
  var savEl = drawer.querySelector('[data-cd-savings]');
  var progEl = drawer.querySelector('[data-cd-progress]');
  var fillEl = drawer.querySelector('[data-cd-fill]');
  var recsEl = drawer.querySelector('[data-cd-recs]');
  var errEl = drawer.querySelector('[data-cd-error]');
  function showError(msg) { if (errEl) { errEl.textContent = msg; errEl.hidden = false; } }
  function clearError() { if (errEl) { errEl.hidden = true; errEl.textContent = ''; } }
  // Format in the shopper's active presentment currency (€ for ROI, £ for NI, etc.).
  // /cart.js amounts are already in that currency — we only need the right symbol.
  var CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  var moneyFmt; try { moneyFmt = new Intl.NumberFormat('en-IE', { style: 'currency', currency: CUR }); } catch (e) { moneyFmt = null; }
  var money = function (c) { return moneyFmt ? moneyFmt.format(c / 100) : '€' + (c / 100).toFixed(2); };
  // Drawer thumbnails are 64–80px, but the cart/recommendation JSON hands back the full-size
  // photo (often 1500px, ~1MB), so on a phone the "You might also like" pictures showed up
  // blank for seconds. Ask Shopify's CDN for a small version instead (2026-09-26).
  var sized = function (u, w) { if (!u) return u; u = String(u); if (u.indexOf('//') === 0) u = 'https:' + u; if (!/cdn\.shopify\.com|\/cdn\/shop\//.test(u)) return u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; };
  var esc = function (s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; };

  // ---- Express wallets, mounted on demand -------------------------------------------------
  // snippets/cart-drawer.liquid parks content_for_additional_checkout_buttons in an inert
  // <template> instead of rendering it into the page. Shopify's own dynamic_checkout.cart
  // bootstrap only pulls the ~378KB portable-wallets.en.js bundle once a
  // <shopify-accelerated-checkout(-cart)> element is IN the document — at DOMContentLoaded if
  // one is already there, otherwise via a MutationObserver on <body>. Parking the markup keeps
  // the homepage and collection pages off that bundle entirely; moving the node in here is what
  // trips the observer, so the wallets load on the shopper's first real look at the basket.
  var walletsForm = drawer.querySelector('[data-cd-wallets]');
  var walletsMounted = false;
  function mountWallets() {
    if (walletsMounted || !walletsForm) return;
    var tpl = walletsForm.querySelector('[data-cd-wallets-src]');
    if (!tpl || !tpl.content) return;                      // no <template> support / already emptied
    walletsMounted = true;
    walletsForm.appendChild(document.importNode(tpl.content, true));
    tpl.parentNode.removeChild(tpl);
    walletsForm.hidden = false;
    warmWallets();
  }
  // Start the bundle downloading without touching the DOM. Used on basket-button hover so the
  // real buttons are usually painted by the time the drawer finishes sliding in, instead of the
  // shopper watching Shopify's grey skeleton. init() rewrites itself to a no-op on first call,
  // so calling it here AND letting the MutationObserver call it later is safe; it is also the
  // fallback if that observer ever disconnected before our node arrived.
  function warmWallets() {
    try {
      if (window.Shopify && Shopify.PaymentButton && typeof Shopify.PaymentButton.init === 'function') Shopify.PaymentButton.init();
    } catch (e) {}
  }
  if (walletsForm) {
    // Mouse/pen only: on a touchscreen pointerenter fires as part of the tap that is already
    // opening the drawer, so it would buy nothing and spend a phone's data on an empty basket.
    document.addEventListener('pointerenter', function (e) {
      if (walletsMounted || e.pointerType === 'touch') return;
      if (!e.target || !e.target.closest || !e.target.closest('.header__cart')) return;
      // Empty basket: nothing to express-checkout, so don't spend ~378KB on a hover. The header
      // count is server-rendered and kept current by updateCount(), so it is right before any fetch.
      var c = document.querySelector('.header__cart-count');
      if (!c || !(parseInt(c.textContent, 10) > 0)) return;
      warmWallets();
    }, true);
  }

  // `inert` keeps the off-screen drawer out of the tab order + a11y tree while
  // closed (fixes "aria-hidden element contains focusable descendants").
  var lastFocus = null;
  var pushed = false;   // did WE push a history entry for the open drawer? (mobile Back closes it)
  // Only VISIBLE focusables — when the basket is empty the footer (checkout / view-basket links)
  // is display:none, and querySelectorAll still returns those hidden links. Including them made
  // `last` a node that can never hold focus, so the forward-Tab trap never fired and focus escaped
  // the drawer to the page behind. offsetParent is null for display:none elements → filtered out.
  function focusables() { return [].filter.call(drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'), function (el) { return el.offsetParent !== null; }); }
  // Wallets go in BEFORE the slide-in class, so the footer is already its final height when the
  // drawer becomes visible. Only when the basket actually has something in it: render() leaves
  // the footer hidden for an empty basket, and there is nothing to express-checkout.
  var cdTitle = drawer.querySelector('.cd__title');
  function open() { clearError(); if (!foot.hidden) mountWallets(); lastFocus = document.activeElement; overlay.classList.add('is-open'); drawer.classList.add('is-open'); drawer.removeAttribute('inert'); drawer.setAttribute('aria-hidden', 'false'); var cb = drawer.querySelector('[data-cd-close]'); if (cb) cb.focus(); if (!pushed) { try { history.pushState({ cdOpen: true }, ''); pushed = true; } catch (e) {} } }
  // teardown = the actual DOM close; close() routes through history so the phone Back button,
  // the X, the overlay tap and Escape all resolve through ONE popstate path and the pushed
  // entry is consumed exactly once (Back closes the drawer instead of leaving the page).
  function teardown() { overlay.classList.remove('is-open'); drawer.classList.remove('is-open'); drawer.setAttribute('inert', ''); drawer.setAttribute('aria-hidden', 'true'); if (lastFocus && lastFocus.focus) { lastFocus.focus(); lastFocus = null; } }
  function close() { if (pushed) { history.back(); } else { teardown(); } }
  window.addEventListener('popstate', function () { if (pushed) { pushed = false; if (drawer.classList.contains('is-open')) teardown(); } });
  // Trap Tab within the open drawer so keyboard focus can't wander behind it.
  drawer.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var f = focusables(); if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  function updateCount(n) {
    document.querySelectorAll('.header__cart-count').forEach(function (el) {
      var prev = parseInt(el.textContent, 10) || 0;
      el.textContent = n; el.style.display = n > 0 ? '' : 'none';
      if (n > prev) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
    });
  }

  // RRP per variant for lines added WITHOUT the _rrp property (collection quick-add, upsell rows,
  // "Goes well with"): cart.js has no compare_at_price, so look it up once from /products/<handle>.js.
  var rrpCache = {}, rrpPending = {};
  function rrpFor(it) {
    var p = it.properties && (it.properties._rrp || it.properties._RRP);
    if (p) return parseInt(p, 10) || 0;
    return rrpCache[it.variant_id] || 0;
  }
  function fillRrp(cart) {
    var need = cart.items.filter(function (it) {
      var p = it.properties && (it.properties._rrp || it.properties._RRP);
      return !p && !(it.variant_id in rrpCache) && it.handle && !rrpPending[it.handle];
    });
    if (!need.length) return;
    Promise.all(need.map(function (it) {
      rrpPending[it.handle] = true;
      return fetch('/products/' + it.handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (pr) {
        (pr && pr.variants || []).forEach(function (v) { rrpCache[v.id] = (v.compare_at_price && v.compare_at_price > v.price) ? v.compare_at_price : 0; });
        if (!(it.variant_id in rrpCache)) rrpCache[it.variant_id] = 0;
      }).catch(function () { rrpCache[it.variant_id] = 0; });
    })).then(function () { render(cart); });
  }

  function render(cart) {
    if (!cart.items || !cart.items.length) {
      body.innerHTML = '<p class="cd__empty">Your basket is empty.</p>';
      foot.hidden = true; if (recsEl) recsEl.innerHTML = ''; return;
    }
    foot.hidden = false;
    // Covers the footer appearing while the drawer is ALREADY open (e.g. an upsell "Add" into a
    // basket that was empty) — open() has been and gone, so it would never mount them.
    if (drawer.classList.contains('is-open')) mountWallets();
    var totalSaved = 0;
    body.innerHTML = cart.items.map(function (it) {
      // RRP passed through as a hidden line-item property on add (cart.js has no
      // compare_at_price). Per-line saving = RRP×qty − what they actually pay.
      var rrpC = rrpFor(it);
      var lineRrp = rrpC * it.quantity;
      var lineSave = (rrpC > 0) ? (lineRrp - it.final_line_price) : 0;
      if (lineSave > 0) totalSaved += lineSave;
      var priceHtml = (lineSave > 0)
        ? '<span class="cd-item__prices"><s class="cd-item__rrp">' + money(lineRrp) + '</s><span class="cd-item__price cd-item__price--sale">' + money(it.final_line_price) + '</span></span>'
        : '<span class="cd-item__price">' + money(it.final_line_price) + '</span>';
      return '<div class="cd-item" data-key="' + esc(it.key) + '">' +
        '<a href="' + esc(it.url) + '" class="cd-item__img">' + (it.image ? '<img src="' + esc(sized(it.image, 240)) + '" alt="" width="104" height="104">' : '') + '</a>' +
        '<div class="cd-item__info">' +
          '<a href="' + esc(it.url) + '" class="cd-item__title">' + esc(it.product_title) + '</a>' +
          (it.variant_title ? '<div class="cd-item__variant">' + esc(it.variant_title) + '</div>' : '') +
          (lineSave > 0 ? '<div class="cd-item__save">Save ' + money(lineSave) + '</div>' : '') +
          '<div class="cd-item__row">' +
            '<div class="cd-qty">' +
              '<button type="button" data-cd-dec aria-label="Decrease quantity">−</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" data-cd-inc aria-label="Increase quantity">+</button>' +
            '</div>' +
            priceHtml +
          '</div>' +
        '</div>' +
        '<button type="button" class="cd-item__remove" data-cd-remove aria-label="Remove">&times;</button>' +
      '</div>';
    }).join('');
    // Plus the basket-level tier discount Shopify applied (€50 off €500 / €100 off €1,000), which is not
    // inside any line's final_line_price.
    (cart.cart_level_discount_applications || []).forEach(function (d) { totalSaved += (d.total_allocated_amount || 0); });
    fillRrp(cart);
    if (savEl) { if (totalSaved > 0) { savEl.hidden = false; savEl.innerHTML = "🎉 You're saving <strong>" + money(totalSaved) + '</strong> today!'; } else { savEl.hidden = true; } }
    subEl.textContent = money(cart.total_price);
    // Savings progress toward the next tier, with the figure bold (and a filled bar).
    // Tier progress = subtotal of discount-eligible items (exclude gift cards, which
    // the €50/€100 doesn't apply to; measured before the order discount).
    var t1 = 50000, t2 = 100000, m, pct;
    var tot = 0; cart.items.forEach(function (it) { if (!it.gift_card) tot += it.final_line_price; });
    var progWrap = drawer.querySelector('.cd__progress');
    if (tot <= 0 || CUR !== 'EUR') {
      // Hide the tier nudge for a gift-card-only basket (no eligible spend) OR when the
      // shopper isn't in the € market. The €50/€100 "Save as You Shop" offer is euro-
      // denominated, so showing it on a £ cart would mislabel the currency; prices above
      // stay correct in local currency and any automatic discount still applies at checkout.
      if (progWrap) progWrap.style.display = 'none';
    } else {
      if (progWrap) progWrap.style.display = '';
      // Bar = fraction of the FULL €1000 goal, so it's MONOTONIC — it never snaps backwards
      // when crossing €500 (the old code refilled toward €50 then reset to 50% at exactly €500).
      pct = Math.min(100, Math.round(tot / t2 * 100));
      if (tot >= t2) { m = "You've unlocked the full <strong>€100 off</strong>."; }
      else if (tot >= t1) { m = '<strong>€50 off</strong> unlocked. <strong>' + money(t2 - tot) + '</strong> more for <strong>€100 off</strong>.'; }
      else { m = 'Spend <strong>' + money(t1 - tot) + '</strong> more to save <strong>€50</strong>.'; }
      progEl.innerHTML = m;
      if (fillEl) fillEl.style.width = pct + '%';
    }
    loadRecs(cart);
  }

  // Contextual upsell based on the WHOLE basket: fetch "related" for each distinct cart
  // product (capped at 3 requests), then merge + rank — a product suggested for several
  // basket items, or ranked highly, floats to the top. Excludes what's already in the cart.
  var recsAnchor = null;
  // "Complete your setup" (2026-10-02): the pairing rules live in sections/main-cart.liquid, which renders
  // live, in-stock products from the matching collection (desk: office chairs, a monitor stand, a filing
  // cabinet; mattress: a bed frame of the same size ...). The drawer asks Shopify for that one section
  // rendered against the current basket and reads its [data-cx] cards, so the drawer and the basket page
  // always suggest the same things. Only when nothing pairs does it fall back to the related list below.
  function loadRecs(cart) {
    if (!recsEl || !cart.items.length) { if (recsEl) recsEl.innerHTML = ''; recsAnchor = null; return; }
    var sig = cart.items.map(function (it) { return it.key + 'x' + it.quantity; }).join(',') + '|' + cart.total_price;
    if (recsAnchor === sig) return;                      // same basket: keep (or keep waiting for) the current list
    recsAnchor = sig;
    fetch('/cart?section_id=main-cart', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { if (!r.ok) throw r.status; return r.text(); })
      .then(function (html) {
        if (recsAnchor !== sig) return;                  // the basket changed while this was in flight
        var box = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cx]');
        var cards = box ? [].slice.call(box.querySelectorAll('[data-cx-item]')) : [];
        if (!cards.length) { loadRelated(cart, sig); return; }
        renderRecs(cards.slice(0, 4).map(function (c) {
          var g = function (k) { return c.getAttribute('data-' + k) || ''; };
          return { url: g('url'), title: g('title'), variant: g('variant'), featured_image: g('img'), price: parseInt(g('price'), 10) || 0, unlock: g('unlock'), variants: [{ id: g('id'), available: true }] };
        }), box.getAttribute('data-cx-title') || 'Complete your setup');
      })
      .catch(function () { if (recsAnchor === sig) loadRelated(cart, sig); });
  }
  // Fallback when nothing pairs: Shopify's related list merged across the basket, as before.
  function loadRelated(cart, sig0) {
    var ids = [], inCart = {};
    cart.items.forEach(function (it) { inCart[it.product_id] = true; if (ids.indexOf(it.product_id) < 0) ids.push(it.product_id); });
    var anchorIds = ids.slice(0, 3);
    // Spend-to-unlock (2026-09-27): when the basket is within €250 of the next tier (€500 → €50 off,
    // €1,000 → €100 off), suggest items that get it over the line first, labelled as such.
    var tot = cart.total_price || 0, tier = tot < 50000 ? 50000 : (tot < 100000 ? 100000 : 0);
    var gap = tier ? tier - tot : 0, prize = tier === 50000 ? '€50' : '€100';
    if (!(gap > 0 && gap <= 25000)) gap = 0;
    var stale = function () { return recsAnchor !== sig0; };
    var rr = function (a, b, c) { if (!stale()) renderRecs(a, b, c); };
    Promise.all(anchorIds.map(function (pid) {
      return fetch('/recommendations/products.json?product_id=' + pid + '&limit=10&intent=related', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); }).then(function (d) { return d.products || []; }).catch(function () { return []; });
    })).then(function (lists) {
      if (stale()) return;
      var score = {}, byId = {};
      lists.forEach(function (products) {
        products.forEach(function (p, i) {
          if (inCart[p.id]) return;                       // never suggest what's already in the basket
          byId[p.id] = p;
          score[p.id] = (score[p.id] || 0) + (4 - i);     // higher rank + recurring across items → higher score
        });
      });
      var ranked = Object.keys(byId).sort(function (a, b) { return score[b] - score[a]; }).map(function (id) { return byId[id]; });
      // Pairs that go together: a desk suggests an office chair, a mattress a bed frame, … Never a second
      // item of the same kind already in the basket.
      var NOUNS = ['desk','chair','mattress','bed','rug','sofa','table','lamp','wardrobe','drawer','shelf','bookcase','stool','bench','rail','frame','ottoman'];
      var PAIR = { desk: 'office-chairs', chair: 'desks', mattress: 'bed-frames', frame: 'mattresses', bed: 'mattresses', sofa: 'coffee-tables', table: 'rugs', rug: 'coffee-tables', wardrobe: 'chests-drawers', drawer: 'nightstands', shelf: 'storage-boxes', bookcase: 'office-chairs', stool: 'dining', bench: 'shoe-storage', rail: 'shoe-storage' };
      var cartNouns = [];
      cart.items.forEach(function (it) { var t = (it.product_title || it.title || '').toLowerCase(); NOUNS.forEach(function (n) { if (t.indexOf(n) > -1 && cartNouns.indexOf(n) < 0) cartNouns.push(n); }); });
      var sameKind = function (p) { var t = (p.title || '').toLowerCase(); return cartNouns.some(function (n) { return t.indexOf(n) > -1; }); };
      var pool = ranked.filter(function (p) { return !sameKind(p); });
      // 2026-10-03 (cro, row 21): profit guard, an unlocker must cost €159+ as well as cover the gap.
      var pickUnlock = function (list) { return list.filter(function (p) { return p.price >= gap && p.price >= 15900 && p.available !== false && !inCart[p.id]; }).sort(function (a, b) { return a.price - b.price; }); };
      var pairCol = null; cartNouns.some(function (n) { if (PAIR[n]) { pairCol = PAIR[n]; return true; } return false; });
      var fromPair = function () {
        if (!pairCol) return Promise.resolve([]);
        return fetch('/collections/' + pairCol + '/products.json?limit=24').then(function (r) { return r.json(); }).then(function (d) {
          return (d.products || []).map(function (p) {
            var v = (p.variants || []).filter(function (x) { return x.available; }).sort(function (a, b) { return parseFloat(a.price) - parseFloat(b.price); })[0];
            if (!v) return null;
            return { id: p.id, title: p.title, url: '/products/' + p.handle, price: Math.round(parseFloat(v.price) * 100), available: true, featured_image: (p.images && p.images[0] && p.images[0].src) || '', variants: [{ id: v.id, available: true }] };
          }).filter(Boolean).filter(function (p) { return !sameKind(p); });
        }).catch(function () { return []; });
      };
      if (gap) {
        var u = pickUnlock(pool);
        if (u.length) { rr(u.slice(0, 3), 'Add one to get ' + prize + ' off', prize); return; }
        return fromPair().then(function (list) {
          var u2 = pickUnlock(list);
          if (u2.length) rr(u2.slice(0, 3), 'Add one to get ' + prize + ' off', prize);
          else rr(pool.length ? pool.slice(0, 3) : list.slice(0, 3));
        });
      }
      if (pool.length) { rr(pool.slice(0, 3)); return; }
      return fromPair().then(function (list) { rr(list.slice(0, 3)); });
    }).catch(function () { if (!stale()) recsEl.innerHTML = ''; });
  }
  function renderRecs(products, title, prize) {
    if (!products.length) { recsEl.innerHTML = ''; return; }
    recsEl.innerHTML = '<div class="cd-recs__title' + (prize ? ' cd-recs__title--unlock' : '') + '">' + esc(title || 'You might also like') + '</div>' + products.map(function (p) {
      var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
      if (!v) return '';
      var unlock = p.unlock || (prize && p.price >= 15900 ? prize : '');
      // Image is a background tile with the photo contained, so tall chairs and wide desks both show whole.
      return '<div class="cd-rec">' +
        '<a href="' + esc(p.url) + '" class="cd-rec__img">' + (p.featured_image ? '<img src="' + esc(sized(p.featured_image, 180)) + '" alt="" width="72" height="72" loading="lazy">' : '') + '</a>' +
        '<div class="cd-rec__info"><a href="' + esc(p.url) + '" class="cd-rec__title">' + esc(p.title) + '</a>' +
        (p.variant ? '<span class="cd-rec__variant">' + esc(p.variant) + '</span>' : '') +
        '<span class="cd-rec__price">' + money(p.price) + (unlock ? ' <span class="cd-rec__unlock">Unlocks ' + esc(unlock) + ' off</span>' : '') + '</span></div>' +
        '<button type="button" class="cd-rec__add" data-rec-add="' + esc(v.id) + '" data-rec-via="' + (unlock ? 'unlock' : 'drawer-pair') + '" aria-label="Add ' + esc(p.title) + ' to basket">Add</button>' +
      '</div>';
    }).join('');
  }

  function load(openAfter) {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { render(c); updateCount(c.item_count); if (openAfter) open(); return c; })
      .catch(function () { if (openAfter) window.location.href = '/cart'; });
  }
  function change(key, qty) {
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json().then(function (c) { return { ok: r.ok, c: c }; }); })
      .then(function (res) {
        // A rejected change (e.g. 422 "not enough items in stock") returns {status,message,
        // description} with NO items. Rendering that showed "Your basket is empty" over a full
        // cart. Instead: re-load the TRUE cart and surface the reason inline.
        if (!res.ok || !res.c || typeof res.c.item_count !== 'number') {
          var msg = (res.c && (res.c.description || res.c.message)) || 'Sorry, we couldn’t update that quantity.';
          return load(false).then(function (c) { showError(msg); return c; });
        }
        clearError(); render(res.c); updateCount(res.c.item_count); return res.c;
      });
  }

  overlay.addEventListener('click', close);
  var cdClose = drawer.querySelector('[data-cd-close]');
  if (cdClose) cdClose.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });

  var busy = false;
  body.addEventListener('click', function (e) {
    var item = e.target.closest('.cd-item'); if (!item || busy) return;
    var key = item.getAttribute('data-key');
    var q = parseInt(item.querySelector('.cd-qty span').textContent, 10) || 1;
    var next = null;
    if (e.target.closest('[data-cd-inc]')) next = q + 1;
    else if (e.target.closest('[data-cd-dec]')) next = q - 1;
    else if (e.target.closest('[data-cd-remove]')) next = 0;
    if (next === null) return;
    busy = true; change(key, next).then(function () { busy = false; }).catch(function () { busy = false; });
  });

  // Any basket button opens the drawer (href stays as a no-JS fallback). Delegated on
  // document so it also catches the mobile bottom-nav basket, which renders AFTER this
  // script runs (binding directly at parse time missed it → it fell through to /cart).
  document.addEventListener('click', function (e) {
    var a = e.target.closest('.header__cart');
    if (a) { e.preventDefault(); if (cdTitle) cdTitle.textContent = 'Your Basket'; load(true); }
  });

  // Upsell "Add" buttons.
  if (recsEl) recsEl.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rec-add]'); if (!btn || busy) return;
    busy = true; btn.textContent = 'Adding…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-rec-add'), 10), quantity: 1, properties: { _via: btn.getAttribute('data-rec-via') || 'drawer-pair' } }] }) })
      .then(function (r) { return r.json(); })
      .then(function () { recsAnchor = null; return load(false); })
      .then(function () { busy = false; })
      .catch(function () { busy = false; btn.textContent = 'Add'; });
  });

  // Public API for the product page add-to-cart.
  // After an Add, the drawer title confirms it; opened from the basket icon it stays "Your Basket".
  function setTitle(added) { if (cdTitle) cdTitle.textContent = added ? '\u2713 Added to your basket' : 'Your Basket'; }
  window.JSHOPCart = { openWithCart: function (o) { setTitle(o && o.added); return load(true); }, refresh: function () { return load(false); } };
})();
